<template>
  <div class="container">
    <!-- 编辑/详情检测类别 -->
    <a-modal
      class=""
      :title="title[numb]"
      :visible="editCategoryVisible"
      @cancel="closeVisible"
      width="60%"
      @ok="submitEditCategory"
    >
      <template slot="footer" v-if="numb == 1">
        <a-button type="primary" @click="closeVisible"> 确定 </a-button>
      </template>
      <div>
        <span>选择所属类别</span>
        <!-- <span>{{substanceList}}</span> -->
      </div>
      <div>
        <div class="containerTop">
          <a-form-model
            :model="substanceList"
            ref="substanceListRef"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  :label-col="{ span: 6 }"
                  class="model_span_form"
                  :wrapper-col="{ span: 18 }"
                  label="行业名称"
                  prop="industryName"
                >
                  <span>{{ substanceList.industryName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  :label-col="{ span: 6 }"
                  class="model_span_form"
                  :wrapper-col="{ span: 18 }"
                  label="检测类别"
                  prop="pollutantName"
                  v-if="numb == 1"
                >
                  <span>{{ substanceList.pollutantName }}</span>
                </a-form-model-item>
                <a-form-model-item
                  v-else
                  :label-col="{ span: 6 }"
                  class="model_span_form"
                  :wrapper-col="{ span: 18 }"
                  label="类别名称"
                  prop="pollutantName"
                  :rules="{
                    required: true,
                    message: '请填写类别名称',
                    trigger: 'change',
                  }"
                >
                  <a-input v-model="substanceList.pollutantName"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12" class="bottom">
                <a-form-model-item
                  :label-col="{ span: 6 }"
                  class="model_span_form"
                  :wrapper-col="{ span: 18 }"
                  label="涉及检测性质"
                  prop="quoteTestNatureList"
                  :rules="{
                    required: true,
                    message: '请选择涉及检测性质',
                    trigger: 'change',
                  }"
                >
                <span v-if="numb == 1">{{substanceList.quoteTestNatureList.join('、')}}</span>
                  <a-checkbox-group
                    v-model="substanceList.quoteTestNatureList"
                    :options="checkout"
                    @change="checkoutChange"
                     v-if="numb == 0"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  :label-col="{ span: 6 }"
                  class="model_span_form"
                  :wrapper-col="{ span: 18 }"
                  label="创建人"
                  prop="creator"
                >
                  <span>{{ substanceList.creator }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  :label-col="{ span: 6 }"
                  class="model_span_form"
                  :wrapper-col="{ span: 18 }"
                  label="创建时间"
                  prop="createTime"
                >
                  <span>{{ substanceList.createTime }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <!-- 表格区域 -->
        <div class="containerTop" id="content_main_center_scroll">
          <a-button type="primary" @click="addCheckMatter" style="margin: 10px" v-if="numb == 0">添加检测物质</a-button>
          <a-table
            :data-source="matterList"
            bordered
            :loading="loading"
            :pagination="false"
            ref="matterListRef"
            :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
          >
            <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
              <template scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column
              key="factorName"
              title="检测物质"
              ellipsis="true"
              data-index="factorName"
              v-if="numb == 0"
            />
            <a-table-column key="factorName" title="污染物名称" ellipsis="true" data-index="factorName" v-else />

            <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
            <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
            <a-table-column title="操作" width="100px" v-if="numb == 0">
              <template scope="text,record">
                <a @click="deletePollution(record)">删除</a>
              </template>
            </a-table-column>
            <a-table-column key="price" title="单价" ellipsis="true" data-index="price" v-else />
          </a-table>
        </div>
        <div>
          <a-modal
            class=""
            title="添加检测物质"
            :visible="matterVisible"
            @cancel="closeMatterVisible"
            width="70%"
            @ok="submit"
          >
            <AddMatter
              :selecteVal="selecteVal"
              :pagination="pagination"
              :examineList="examineList"
              :selectedRowKeys="selectedRowKeys"
              @changeData="getList"
              @getVal="getVal"
              @changeList="changeList"
            ></AddMatter>
          </a-modal>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getCheckedlist } from '@/api/Industry'
import {
  getRelationBaseFactor,
  getQuoteBaseFactorRelationList,
  getQuoteRelationFactorList,
  addRelationCaregoryAndPollutant,
  pollutantDelete,
  editPollutantType,
  deleteTestPollutant,
} from '@/api/surrounding'
import AddMatter from './addMatter.vue'
export default {
  components: {
    AddMatter,
  },
  props: [
    'editCategoryVisible',
    'numb',
    //  'substanceList',
    'matterList',
  ],
  data() {
    return {
      typeIndex: 0,
      substanceList: [],
      checkoutData: [],
      checkout: ['发证、复证', '一般委托', '监督检测'],
      // substanceList:{},
      title: ['编辑检测类别', '检测类别-详情'],
      // matterList: [],
      scroll_y: 150,
      matterVisible: false,
      pagination: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      examineList: [],
      selectedRowKeys: {
        1: [],
      },
      ids: [],
      data: {},
      selecteVal: [],
      editCategoryData: [],
    }
  },
  created() {
    var max_h = $('#content_main_center_scroll').height()
    setTimeout(() => {
      this.scroll_y = max_h - $('.ant-table-header').height() + 400
    }, 1000)
  },
  methods: {
    init(data) {
      var array = []
      getCheckedlist({
        natureIds: data.natureIds,
      }).then((res) => {
        if (res.code == 200) {
          res.data.list.forEach((item) => {
            if (item.checked == 1) {
              array.push(item.natureName)
            }
          })
          Object.assign(data, {
            quoteTestNatureList: array,
          })
          this.substanceList = JSON.parse(JSON.stringify(data))
          this.checkoutData = res.data.list
        }
      })
      this.editCategoryData = JSON.parse(JSON.stringify(data))
    },
    //改变检测物质
    checkoutChange() {
      this.typeIndex = 1
    },
    //删除
    deletePollution(record) {
      console.log(record, 'record===========================')
      console.log(this.substanceList, 'substanceList========================')
      var _this = this
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          //   pollutantDelete
          // pollutantId

          deleteTestPollutant({
            id: _this.substanceList.id,
            pollutantId: record.id,
          }).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.msg)
              _this.$emit('changePollution')
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          _this.$message.warning('你点击了取消')
        },
      })
    },
    changeList(data) {
      this.data = data
      console.log(data, 'searchData==============')
      this.getList()
    },
    getVal(data) {
      this.ids = []
      // val.forEach(item => {
      //     this.ids.push(item.id)
      // })
      var obj = data
      // var ids = []
      for (let i in obj) {
        obj[i].forEach((item) => {
          this.ids.push(item.id)
        })
      }
    },
    getList(data) {
      if (data) {
        this.pagination.current = data.current
        this.pagination.pageSize = data.pageSize
      }
      getQuoteBaseFactorRelationList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        id: this.substanceList.id,
        subcategoryId: this.data.subcategoryId,
        factorName: this.data.factorName,
        categoryId: 1000,
      }).then((res) => {
        if (res.code == 200) {
          this.examineList = res.data.list
          this.pagination.totalCount = res.data.totalCount
        }
      })
    },

    //添加检测物质事件
    addCheckMatter() {
      this.getList()

      this.matterVisible = true
    },
    //关闭添加检测物质弹窗
    closeMatterVisible() {
      this.matterVisible = false
    },
    // 弹窗关闭事件
    closeVisible() {
      this.editCategoryVisible = false
      this.$emit('changeEditCategoryVisible', this.editCategoryVisible)
    },
    closeVisible() {
      this.editCategoryVisible = false
      this.$emit('changeEditCategoryVisible', this.editCategoryVisible)
    },
    submitEditCategory() {
      if (this.numb == 0) {
        var data = []
        this.checkoutData.forEach((item) => {
          this.substanceList.quoteTestNatureList.forEach((item1) => {
            if (item.natureName == item1) {
              data.push(item)
            }
          })
        })
        this.substanceList.quoteTestNatureList = data
        if (this.editCategoryData.pollutantName === this.substanceList.pollutantName && this.typeIndex == 0) {
          this.editCategoryVisible = false
          this.$emit('changeEditCategoryVisible', this.editCategoryVisible)
        } else {
          // 调用编辑接口
          editPollutantType({
            id: this.substanceList.id,
            pollutantName: this.substanceList.pollutantName,
            quoteTestNatureList: this.substanceList.quoteTestNatureList,
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              //刷新数据列表
              this.$emit('getData')
              this.editCategoryVisible = false
              this.$emit('changeEditCategoryVisible', this.editCategoryVisible)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      }
    },
    // 弹窗提交事件
    submit() {
      if (this.data) {
        addRelationCaregoryAndPollutant({
          id: this.substanceList.id,
          ids: this.ids,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.matterVisible = false
            this.selectedRowKeys = { 1: [] }
            this.selecteVal = []
            this.$emit('changePollution', this.substanceList)
          } else {
          }
        })
      } else {
        this.$message.warning('请选择需要添加的物质！')
      }
    },
  },
}
</script>

<style>
.containerTop {
  margin: 10px;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #fff;
  border-radius: 15px;
}
</style>